import React, { useState, useEffect } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { Button } from '@progress/kendo-react-buttons';
import { useSearchParams } from 'react-router-dom';
import Cookies from 'js-cookie';
import { getProperties } from '../../../api/form-entries-api';
import { CustomLoader } from "src/components";
import {settingsService} from "../../../services/settings.service";
interface Property {
  prop_id: any;  
}
interface PageInfo { skip: number; take: number; }
const PAGE_SIZE = 20;

export default function PropertySearchPopup({
  showPopup,
  formName,
  onClose,
  onPropertySelect,
}: {
  showPopup: boolean;
  formName:string |undefined;
  onClose: () => void;
   onPropertySelect: () => void;
}) {
  const [searchParams] = useSearchParams();
  const [propertyIds, setPropertyIds] = useState<Property[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState<PageInfo>({ skip: 0, take: PAGE_SIZE });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
 const settings = settingsService().settings;
  useEffect(() => {
    if (!showPopup) {
      setPropertyIds([]);
      setSearchTerm('');
      setPage({ skip: 0, take: PAGE_SIZE });
      setError(null);
      setIsLoading(false);
      return;
    }

    const ownerId =searchParams.get('ownerId') ?? Cookies.get('ownerId') ?? undefined;
    const yearStr = searchParams.get('year') ?? Cookies.get('year') ?? undefined;
    const loggedInMode = Cookies.get('loggedInMode') ?? undefined;
   const associateAccId = Cookies.get('associateAccId') ?? null;
    if (!ownerId || !yearStr || !loggedInMode ) {
      
      return;
    }

    const year = parseInt(yearStr, 10);
    if (isNaN(year)) {
     // setError('Invalid year: ' + yearStr);
      return;
    }

    setIsLoading(true);
    setError(null);

    const controller = new AbortController();
    getProperties(ownerId, year, loggedInMode,associateAccId!,formName!)
      .then((res) => {
        if (Array.isArray(res.data)) {
             setPropertyIds(res.data);
        setPage((p) => ({ ...p, skip: 0 }));
        }
      
      })
      .catch((err) => {
        
      })
      .finally(() => {
        setIsLoading(false);
      });

    return () => controller.abort();
  }, [showPopup, searchParams]);

  if (!showPopup) return null;

  const filtered = propertyIds.filter((item) => {
    const pid = item.prop_id;
    if (pid === null || pid === undefined) return false;
    // Safely convert any value to string
    return String(pid)
      .toLowerCase()
      .includes(searchTerm.trim().toLowerCase());
  });
  const paged = filtered.slice(page.skip, page.skip + page.take);

  return (
    <Dialog title="Search Property IDs" onClose={onClose}>
      <div style={{ marginBottom: '1rem' }}>
        <input
          type="text"
          placeholder="Search Property ID…"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setPage((p) => ({ ...p, skip: 0 }));
          }}
          className="k-textbox"
          style={{ width: '70%', marginRight: '0.5rem' }}
        />
      </div>

      {isLoading &&  <CustomLoader /> }
        <Grid
          style={{ height: 300, width: '100%' }}
          data={paged}
          skip={page.skip}
          take={page.take}
          total={filtered.length}
          pageable
          onPageChange={(e) => setPage(e.page)}
          onRowClick={(e) => {
    const id =settings.isHarrisClient?  e.dataItem.prop_id:e.dataItem.PropertyId;
    Cookies.set('propertyId', id);
    onClose();
    onPropertySelect();
  }}
        >
          <Column field="prop_id" title="Property ID" />
        </Grid>
      

      <DialogActionsBar>
        <Button onClick={onClose}>Close</Button>
      </DialogActionsBar>
    </Dialog>
  );
}
